<template>
  <div class="left">
    <div>
      <font-awesome-icon id="" :icon="['fas', 'xmark']" size="6x" />
    </div>
    <div class="success text-title">
      <p> {{ $vt('An error occurred while processing your order.') }} </p>
      <p> {{ $vt('The support team has been notified, but you can also contact them.') }}</p>
    </div>
    <div>
      <f-button type="tertiary" blank
        href="mailto:support@vodalys.com?subject=Order still processing"><font-awesome-icon
          :icon="['far', 'envelope']" /> support@vodalys.com</f-button>
    </div>
  </div>
</template>
<script>
export default {
  translate25Context: 'stripe',
  props: ["component", "handler"],
}
</script>
<style scoped>
.fa-xmark {
  color: var(--statusNegative)
}
</style>